__turbopack_context__.v({
  "benefitCard": "DesignSprintsSection-module__pky0eG__benefitCard",
  "benefitLabel": "DesignSprintsSection-module__pky0eG__benefitLabel",
  "benefitsGrid": "DesignSprintsSection-module__pky0eG__benefitsGrid",
  "cardLink": "DesignSprintsSection-module__pky0eG__cardLink",
  "ctaRow": "DesignSprintsSection-module__pky0eG__ctaRow",
  "description": "DesignSprintsSection-module__pky0eG__description",
  "engagementDetail": "DesignSprintsSection-module__pky0eG__engagementDetail",
  "engagementDuration": "DesignSprintsSection-module__pky0eG__engagementDuration",
  "engagementHeader": "DesignSprintsSection-module__pky0eG__engagementHeader",
  "intro": "DesignSprintsSection-module__pky0eG__intro",
  "layout": "DesignSprintsSection-module__pky0eG__layout",
  "title": "DesignSprintsSection-module__pky0eG__title",
});
